import { ChevronRight } from "lucide-react";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { IgTypography } from "@intelligems/ig-theme";
import { Breadcrumbs, Grid } from "@mui/material";
import {
  AdminRoutes,
  BillingRoutes,
  StandardRoutes,
} from "@src/components/Utils/routes";
import { useSelector } from "@src/store";
import { selectedExperience } from "@src/store/slices/experiences";

const breadcrumbObj = {
  noChildren: [
    StandardRoutes().home.path,
    StandardRoutes().eventsManager.path,
    StandardRoutes().widgetLibrary.path,
    StandardRoutes().integrations.path,
    StandardRoutes().settings.path,
    AdminRoutes().configCompare.path,
    AdminRoutes().performance.path,
  ],
  billingRoutes: [BillingRoutes.agency.path, BillingRoutes.overview.path],
};

export const IgPageContentBreadcrumbs = () => {
  const experience = useSelector(selectedExperience);
  const path = window.location.pathname;

  const navigate = useNavigate();
  const buildBreadcrumbs = useMemo(() => {
    if (breadcrumbObj.noChildren.includes(path)) return [];
    if (breadcrumbObj.billingRoutes.includes(path)) {
      return [
        <IgTypography key={1}>Billing</IgTypography>,
        <IgTypography key={2}>
          {
            BillingRoutes[path.includes("overview") ? "overview" : "agency"]
              .sidebarName
          }
        </IgTypography>,
      ];
    }
    if (experience) {
      return [
        <IgTypography
          sx={{
            "&:hover": { cursor: "pointer", textDecoration: "underline" },
          }}
          onClick={() => {
            void navigate(
              StandardRoutes()[
                experience.category === "experiment"
                  ? "experiments"
                  : "personalizations"
              ]?.path
            );
          }}
          key={1}
        >
          {
            StandardRoutes()[
              experience.category === "experiment"
                ? "experiments"
                : "personalizations"
            ]?.sidebarName
          }
        </IgTypography>,
        <IgTypography key={2}>{experience.name}</IgTypography>,
      ];
    }
    return [];
  }, [experience, path]);

  return (
    <Grid item>
      <Breadcrumbs
        sx={{
          "& .MuiBreadcrumbs-li": { maxWidth: "410px" },
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        separator={<ChevronRight size={16} />}
      >
        {buildBreadcrumbs}
      </Breadcrumbs>
    </Grid>
  );
};
